// extracted by css-extract-rspack-plugin
export default {"Spacer":"Spacer-module__Spacer__urjg0i6"};